import { remCSS } from '@gimlite/common';
import classNames from 'classnames';
import React, { memo } from 'react';
import './col.component.scss';

export declare namespace ColType {
  type Props = {
    className?: string | null;
    children?: React.ReactNode | null;
    justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
    alignItems?: 'flex-start' | 'center' | 'flex-end';
    gap?: number | null;
    width?: number | string;
    height?: number | string;
    overflowY?: 'initial' | 'auto';
    columnExtend?: number | null;
  };
}

export const Col = memo(
  ({
    children,
    className,
    justifyContent = 'flex-start',
    alignItems = 'flex-start',
    gap = 0,
    width = 'initial',
    height = 'initial',
    overflowY = 'initial',
    columnExtend = 1,
  }: ColType.Props) => {
    return (
      <div
        style={{
          justifyContent,
          alignItems,
          gap: `${remCSS(gap || 0)}`,
          width,
          height,
          overflowY,
          gridColumn: `span ${columnExtend}`,
        }}
        className={classNames('col', className)}
      >
        {children}
      </div>
    );
  },
);
